import { render } from "./UploadSelfie.vue?vue&type=template&id=7d99d4f0"
import script from "./UploadSelfie.vue?vue&type=script&lang=js"
export * from "./UploadSelfie.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__